document.addEventListener('DOMContentLoaded', function () {

  const enquiryButton = document.getElementById('CommonEnquiryButton');
  const enquiryPopup = document.getElementById('CommonEnquiryPopup');
  const enquiryClose = document.getElementById('CommonEnquiryClose');
  const enquiryOverlay = enquiryPopup
    ? enquiryPopup.querySelector('.common-enquiry-overlay')
    : null;

  if (!enquiryButton || !enquiryPopup) {
    return;
  }


  /* ---------------------------------------------------------
     OPEN POPUP
     --------------------------------------------------------- */

  function openEnquiryPopup() {

    enquiryPopup.classList.add('is-open');

    enquiryPopup.setAttribute('aria-hidden', 'false');

    document.body.style.overflow = 'hidden';

    // Focus close button for accessibility
    if (enquiryClose) {
      setTimeout(function () {
        enquiryClose.focus();
      }, 100);
    }
  }


  /* ---------------------------------------------------------
     CLOSE POPUP
     --------------------------------------------------------- */

  function closeEnquiryPopup() {

    enquiryPopup.classList.remove('is-open');

    enquiryPopup.setAttribute('aria-hidden', 'true');

    document.body.style.overflow = '';
  }


  /* ---------------------------------------------------------
     OPEN BUTTON
     --------------------------------------------------------- */

  enquiryButton.addEventListener('click', function (event) {

    event.preventDefault();

    openEnquiryPopup();

  });


  /* ---------------------------------------------------------
     CLOSE BUTTON
     --------------------------------------------------------- */

  if (enquiryClose) {

    enquiryClose.addEventListener('click', function (event) {

      event.preventDefault();

      closeEnquiryPopup();

    });

  }


  /* ---------------------------------------------------------
     CLOSE WHEN CLICKING OVERLAY
     --------------------------------------------------------- */

  if (enquiryOverlay) {

    enquiryOverlay.addEventListener('click', function () {

      closeEnquiryPopup();

    });

  }


  /* ---------------------------------------------------------
     ESC KEY TO CLOSE
     --------------------------------------------------------- */

  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      enquiryPopup.classList.contains('is-open')
    ) {

      closeEnquiryPopup();

    }

  });


  /* ---------------------------------------------------------
     SEND OTP BUTTON
     --------------------------------------------------------- */

  const sendOTPButton = document.getElementById('CommonEnquirySendOTP');
  const mobileInput = document.getElementById('CommonEnquiryMobile');
  const mobileError = document.getElementById('CommonEnquiryMobileError');


  if (sendOTPButton && mobileInput) {

    sendOTPButton.addEventListener('click', function () {

      const mobileNumber = mobileInput.value.trim();


      // Clear previous error
      if (mobileError) {
        mobileError.textContent = '';
      }


      // Remove non-numeric characters
      const cleanMobile = mobileNumber.replace(/\D/g, '');

      mobileInput.value = cleanMobile;


      // Indian mobile number validation
      const mobilePattern = /^[6-9]\d{9}$/;


      if (!mobilePattern.test(cleanMobile)) {

        if (mobileError) {
          mobileError.textContent =
            'Please enter a valid 10-digit mobile number.';
        }

        mobileInput.focus();

        return;
      }


      /*
       * OTP integration will be added here.
       *
       * Currently this only validates the mobile number.
       * No OTP is actually sent yet.
       */

      if (mobileError) {
        mobileError.textContent =
          'Mobile number verified. OTP integration will be connected next.';
      }

    });

  }

});